import store from '../store';
import Constants from '../config/constants';
import {
    serviceCreateNotice,
    serviceDeleteNotice,
    serviceGetNotice,
    serviceUpdateNotice,
} from '../services/Notice.service';

export const FETCH_INIT    = 'FETCH_INIT_Notice';
export const FETCHED       = 'FETCHED_Notice';
export const FETCHED_FAIL  = 'FETCHED_FAIL_Notice';
export const SET_SORTING   = 'SET_SORTING_Notice';
export const SET_FILTER    = 'SET_FILTER_Notice';
export const CHANGE_PAGE   = 'CHANGE_PAGE_Notice';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_Notice';
export const CREATE_DATA   = 'CREATE_Notice';
export const UPDATE_DATA   = 'UPDATE_Notice';
export const DELETE_ITEM   = 'DELETE_Notice';

export function actionFetchNotice(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetNotice({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({ type: FETCH_INIT });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index === 1) dispatch({ type: CHANGE_PAGE, payload: 0 });
            } else {
                dispatch({ type: FETCHED_FAIL });
            }
        });
    };
}

export function actionCreateNotice(data) {
    const request = serviceCreateNotice(data);
    return (dispatch) => {
        request.then((res) => {
            if (!res.error) dispatch({ type: CREATE_DATA, payload: res.data });
        });
    };
}

export function actionUpdateNotice(data) {
    const request = serviceUpdateNotice(data);
    return (dispatch) => {
        request.then((res) => {
            if (!res.error) dispatch({ type: UPDATE_DATA, payload: res.data });
        });
    };
}

export function actionDeleteNotice(id) {
    return (dispatch) => {
        serviceDeleteNotice({ id });
        dispatch({ type: DELETE_ITEM, payload: id });
    };
}

export function actionSetPageNotice(page) {
    const stateData = store.getState().notice;
    const totalLength = stateData?.all.length;
    const sortingData = stateData?.sorting_data;
    const query = stateData?.query;
    const queryData = stateData?.query_data;
    const serverPage = stateData?.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchNotice(serverPage + 1, sortingData, { query, query_data: queryData }));
    }
    return { type: CHANGE_PAGE, payload: page };
}
